import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

const base = (clientViewId) => `/views/${clientViewId}/servicios`;

export function listVendorDirectoryDuplicateMatches(clientViewId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/duplicados${buildClientQuery(params)}`);
}

export function getVendorDirectoryDuplicateMatch(clientViewId, matchId) {
  return clientPortalRequest(`${base(clientViewId)}/duplicados/${matchId}`);
}

export function scanVendorDirectoryCandidateDuplicates(clientViewId, candidateId) {
  return clientPortalRequest(`${base(clientViewId)}/candidatos/${candidateId}/duplicados/escanear`, {
    method: "POST",
  });
}

export function scanVendorDirectoryVendorDuplicates(clientViewId, vendorId) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/duplicados/escanear`, {
    method: "POST",
  });
}

export function normalizeVendorDirectoryCandidate(clientViewId, candidateId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/candidatos/${candidateId}/normalizar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function keepVendorDirectoryRecordsSeparate(clientViewId, matchId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/duplicados/${matchId}/separar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function deferVendorDirectoryDuplicateMatch(clientViewId, matchId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/duplicados/${matchId}/aplazar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function previewVendorDirectoryCandidateLink(clientViewId, matchId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/duplicados/${matchId}/vincular/preview`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function executeVendorDirectoryCandidateLink(clientViewId, matchId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/duplicados/${matchId}/vincular`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function previewVendorDirectoryMerge(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/fusionar/preview`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function executeVendorDirectoryMerge(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/fusionar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function reverseVendorDirectoryMerge(clientViewId, mergeId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/fusiones/${mergeId}/revertir`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
